import { Link } from '@chegg/fanta'
import styled from 'styled-components'
import { CheckmarkIcon, spacing, font } from '@chegg-ui/theme'
import { adjust, themeBreakPoints } from '@chegg-wt/core/theme/theme'
import {
  DropdownButtonMedium,
  DropdownButtonSmall,
} from '@chegg-wt/core/theme/sunkist/buttons'
import { BodyLargeBold } from '@chegg-wt/core/theme/sunkist/typography'
import Icon from '../Icon'
import { DropdownAlignment } from '.'

export const DropdownWrapper = styled.div`
  position: relative;
  flex-grow: 1;
`

export const DropdownContainer = styled.div<{
  width: string
  alignment: DropdownAlignment
  visuallyHidden: boolean
}>`
  ${({ visuallyHidden }) => (visuallyHidden ? 'visibility: hidden;' : '')};
  background-color: white;
  overflow-y: hidden;
  position: absolute;
  bottom: auto;
  ${({ alignment }) => (alignment === 'right' ? 'right: 0;' : '')};
  width: 100%;
  border-radius: 3px;
  z-index: 1;
  border: 1px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor13};
  min-width: ${({ width }) => {
    if (width === 'small') return '160px'
    if (width === 'large') return '400px'
    return '300px'
  }};
  @media (max-width: ${({ theme }) => adjust(themeBreakPoints.medium(theme), -1)}) {
    min-width: ${({ width }) => {
      if (width === 'small') return '160px'
      if (width === 'large') return '240px'
      return '250px'
    }};
  }
`

export const OptionsContainer = styled.div`
  overflow-y: auto;
  max-height: 360px;
`

export interface OptionProps {
  width: string
  selected?: boolean
}

export const ButtonOption = styled.button<OptionProps>`
  ${({ width }) => {
    if (width === 'small') return DropdownButtonSmall
    /* if (width === 'large') return Sunkist.Buttons.DropdownButtonMedium */
    return DropdownButtonMedium
  }}
  ${(props) => props.selected && BodyLargeBold};
`

export const LinkOption = styled(Link)<OptionProps>`
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
  height: 65px;
  width: 100%;
  border-bottom: ${({ theme }) =>
    `1px solid ${theme.Colors.forInterface.interfaceColor13}`};

  &&& {
    color: inherit;
    font-size: ${font.size.px16};
    font-weight: ${font.weight.normal};
    text-decoration: none;
    ${({ selected }) => (selected ? `font-weight: ${font.weight.bold};` : '')};

    &:hover,
    :focus,
    :active {
      background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor19};
    }
  }
`

export const StylesDropdown = styled(DropdownContainer)`
  border: 1px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor13};
  border-radius: 4px;
  z-index: 1;
  & > * + * {
    border-top: 1px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor13};
  }
`

export const Check = styled(Icon)`
  height: 20px;
  width: 25px;
  margin: 0;
  color: ${({ theme }) => theme.Colors.forInterface.interfaceColor01};
  position: absolute;
  left: 5px;
  top: 50%;
  transform: translateY(-50%);
`

const SELECTED_WIDTH = '40px'

export const SelectedContainer = styled.div`
  height: 42px;
  width: ${SELECTED_WIDTH};
  > svg {
    color: ${({ theme }) => theme.Colors.forInterface.interfaceColor01};
  }
`

export const OptionName = styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const Checkmark = styled(CheckmarkIcon)`
  margin-left: ${spacing.px4};
  margin-top: ${spacing.px8};
`
